import { memo, useEffect } from "react";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthRoute = memo(function AuthRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  const { lang } = useSelector((state) => state?.langProvider);

  const [searchParams] = useSearchParams();
  let token = searchParams.get("token");
  let callback = searchParams.get("callback");

  //   useEffect(() => {
  //   if (session.status === "authorized" && session?.user?.role) {
  //     // run your redirects
  //   }
  // }, [session.status, session?.user?.role]);

  useEffect(() => {
    if (session.status === "authorized") {
      const currentPath = window.location.pathname;

      if (token && currentPath !== "/accept-user") {
        navigate(`/accept-user?token=${token}`);
        return;
      }

      if (!token) {
        if (session?.user?.role?.toLowerCase() === "admin") {
          navigate(`/${lang}/admin/events`);
          return;
        }
        if (session?.user?.role?.toLowerCase() === "organization") {
          navigate(callback ? callback : `/${lang}/user/events`);
          return;
        }
        if (session?.user?.role?.toLowerCase() === "user") {
          navigate(callback ? callback : `/${lang}`);
          return;
        }
      }
    }
  }, [session.status, session?.user?.role?.toLowerCase(), token, navigate]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  return session.status === "unauthorized" ? children : "null";
});

export default AuthRoute;
